import { render } from "./TheHeader.vue?vue&type=template&id=88215518&scoped=true"
import script from "./TheHeader.vue?vue&type=script&lang=js"
export * from "./TheHeader.vue?vue&type=script&lang=js"

import "./TheHeader.vue?vue&type=style&index=0&id=88215518&scoped=true&lang=css"

import exportComponent from "C:\\Users\\THULIB\\Documents\\GitHub\\Coach-Finder-Vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88215518"]])

export default __exports__